// extracted by mini-css-extract-plugin
module.exports = {"theaterNameForm":"TheatreCreateNameForm_theaterNameForm__1gg5I","warning":"TheatreCreateNameForm_warning__2j7KV","input":"TheatreCreateNameForm_input__XiZBa"};